var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c(_setup.SImageLazy, {
    attrs: {
      "src": _setup.plan,
      "alt": "Планировка квартиры",
      "fade": ""
    },
    on: {
      "error": _setup.errorHandler
    }
  });
};
var staticRenderFns = [];
export { render, staticRenderFns };